import { useMutation } from '@apollo/client/react';
import type { AnonymousUser } from '@blinq-types';
import { CreateUserDocDocument } from '@graphql/mutations/user/create-user-doc.graphql';
import { useFeatureFlag } from '@modules/feature-flag';
import { cacheUser, fetchGclid, oldCreateUser } from '@modules/user-doc-helpers';

export const useCreateUserDoc = () => {
  const [create, { loading: loadingCreate }] = useMutation(CreateUserDocDocument);
  const [useGraphQl, { loading: loadingUseGraphQl }] = useFeatureFlag(
    'schrodinger_create_update_user_doc',
    'off',
  );

  const createUserDoc = async (input: AnonymousUser, cache = true) => {
    // this was saved earlier in the user create flow
    // update it here just in case
    input.gclid = fetchGclid(input.userId);

    if (cache) cacheUser(input);

    await create({
      variables: {
        input: {
          data: {
            ...input,
          },
        },
      },
    });
  };

  return {
    createUserDoc: useGraphQl === 'on' ? createUserDoc : oldCreateUser,
    loading: loadingCreate || loadingUseGraphQl,
  };
};
